/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetSummarySiteResponseDto
 */
export interface AssetSummarySiteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSummarySiteResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSummarySiteResponseDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AssetSummarySiteResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSummarySiteResponseDto
     */
    longitude: number | null;
}

/**
 * Check if a given object implements the AssetSummarySiteResponseDto interface.
 */
export function instanceOfAssetSummarySiteResponseDto(value: object): value is AssetSummarySiteResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function AssetSummarySiteResponseDtoFromJSON(json: any): AssetSummarySiteResponseDto {
    return AssetSummarySiteResponseDtoFromJSONTyped(json, false);
}

export function AssetSummarySiteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSummarySiteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function AssetSummarySiteResponseDtoToJSON(json: any): AssetSummarySiteResponseDto {
    return AssetSummarySiteResponseDtoToJSONTyped(json, false);
}

export function AssetSummarySiteResponseDtoToJSONTyped(value?: AssetSummarySiteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

